import styles from './CounterBadge.module.scss';

export const CounterBadge = ({ count }) => !!count && <div className={styles['count-indication']}>{count}</div>;
